/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_NameInputs */

const vi_grower_area_name = /** @type {(inputs: Grower_Area_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên vùng`)
};

/**

* @param {Grower_Area_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_name = /** @type {((inputs?: Grower_Area_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_name(inputs)
});